module.exports = __webpack_public_path__ + "static/img/2备份 6.94a963e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/milan/2备份 6.png
// module id = yAxt
// module chunks = 1